export const BTC_DECIMAL_PLACES = 8;
export const BBN_DECIMAL_PLACES = 5;
export const WINDOW_BREAKPOINT = 640;
export const MAX_WINDOW_HEIGHT = 500;